import {ChangeDetectionStrategy, Component} from '@angular/core';
import {MatIcon} from '@angular/material/icon';

@Component({
  selector: 'app-mobile-only',
  imports: [
    MatIcon
  ],
  templateUrl: './mobile-only.html',
  styleUrl: './mobile-only.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MobileOnly {

}
